import "custom-event-polyfill";

export class Cursor {
    private static waiting = false;
    private static beginEvent = new CustomEvent("begin-loading-indicator");
    private static endEvent = new CustomEvent("end-loading-indicator");
    public static begin(): void {
        this.waiting = true;
        document["s6activeRequestCount"] = document["s6activeRequestCount"] || 0;
        document["s6activeRequestCount"]++;
        setTimeout(() => {
            if (this.waiting) {
                document.body.style.cursor = "wait";
                document.body.dispatchEvent(this.beginEvent);
            }
        }, 250);
    }
    public static end(): void {
        document["s6activeRequestCount"]--;
        this.waiting = false;
        document.body.style.cursor = "auto";
        document.body.dispatchEvent(this.endEvent);
    }
}
